export const PAYMENTS_MERCHANTS = [
  { type: 'cloudpayments', iframe: true, gate: '1' },
  { type: 'tinkoff', iframe: true, gate: '10' },
  { type: 'prodamus', iframe: true, gate: '11' },
  { type: 'tinkoff_sbp', iframe: false, gate: '12' },
  { type: 'paytabs', iframe: false, gate: '3' },
  { type: 'terpay', iframe: false, gate: '13' },
  { type: 'moneta', iframe: true, gate: '14' },
  { type: 'moneta_v2', iframe: false, gate: '2' },
  { type: 'rr', iframe: false, gate: '8' },
  { type: 'instalment_tinkoff', iframe: false, gate: '4' },
  { type: 'instalment_sber', iframe: false, gate: '5' },
  { type: 'instalment_postcredit', iframe: false, gate: '6' },
  { type: 'instalment_gosuslugi', iframe: false, gate: '7' },
  { type: '7pay', iframe: false, gate: '9' }
]
